"use client";

import { useTranslation } from "@/lib/i18n";
import { cn } from "@/lib/utils";
import { ArrowRight, Lock } from "lucide-react";
import React from "react";

type CreateMyCvButtonProps = {
  hideBottomText?: boolean;
};

const CreateMyCvButton: React.FC<CreateMyCvButtonProps> = ({
  hideBottomText,
}) => {
  const { t } = useTranslation({ ns: "website" });
  return (
    <div>
      <div className="mt-16 flex justify-center">
        <a
          className={cn(
            "relative inline-flex h-10 w-fit items-center justify-center overflow-hidden",
            "focus-visible:ring-ring group rounded-xl p-[2px] text-sm font-semibold text-primary-foreground ring-offset-background transition-all duration-300 md:scale-[1.5] md:hover:scale-[1.6] md:active:scale-[1.5]",
            "hover:rounded-2xl hover:bg-primary/90 focus-visible:outline-none focus-visible:ring-2 active:rounded-xl active:duration-150 disabled:cursor-not-allowed disabled:opacity-50",
            "bg-primary bg-gradient-to-bl from-indigo-400 via-blue-400 to-emerald-400",
          )}
          href="/home"
        >
          <span className="inline-flex h-full w-fit items-center gap-1 rounded-[10px] bg-white/90 px-4 py-2 text-black transition-all duration-300 group-hover:rounded-2xl group-hover:bg-white/0 group-hover:text-white dark:bg-black/80 dark:text-white group-hover:dark:bg-black/0 dark:group-hover:text-black">
            <p className="font-medium">{t("Create my CV")}</p>
            <ArrowRight size={18} />
          </span>
        </a>
      </div>

      {!hideBottomText && (
        <div className="mt-6 flex justify-center">
          <p className="flex justify-center gap-1">
            <Lock size={18} />
            {t("Security Protected")}
          </p>
        </div>
      )}
    </div>
  );
};

export default CreateMyCvButton;
